import React from "react";
import styles from "./navStepperItem.module.scss";
import { useHistory, useLocation } from "react-router-dom";

type Props = {
  title: string;
  routePath: string;
  number: number;
  completed?: boolean;
  visited?: boolean;
};

const NavStepperItem = ({
  title,
  routePath,
  number,
  completed = false,
  visited = false,
}: Props) => {
  // router
  const history = useHistory();
  const location = useLocation();

  // helpers
  const getStepClass = () => {
    let activeClass = location.pathname.endsWith(routePath)
      ? ` ${styles.active}`
      : "";
    let comletedClass = completed === true ? ` ${styles.completed}` : "";
    let visitedClass = visited === true ? ` ${styles.visited}` : "";

    return `${styles.stepItem}${comletedClass}${visitedClass}${activeClass}`;
  };

  // handlers
  const locationChangeHandler = () => {
    // TODO: docasne zakazani preklikavani pres Stepper (az se doresi validace na posledním kroku - odkomentovat)
    // history.push(routePath); 
  };

  // render
  return (
    <div className={getStepClass()}>
      <div className={styles.stepContent}>
        <div onClick={locationChangeHandler} className={styles.stepLink}>
          <div className={styles.stepIndicator}>{number}</div>
          <div className={styles.stepTitle}>{title}</div>
        </div>
      </div>
    </div>
  );
};

export default NavStepperItem;
